new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#app_header',
    data: {
        header: {
          useFirst: true, // first headerBar
          myaccount_options: 'dropdown', // 'none' = no dropdowns, 'dropdown' = hover and dropdown menu;
          isNavUp: true,
          isNavDown: true,
          isNavMin: false,
          lastScrollTop: 0,
          menuMobile: false,
          openCategorysMobile: false,
        },
        searchOpened: false,
        cartOpened: false,
    },
    methods: {
      addPaddingHeader() {
        const headerTransparent = document.querySelector('.nav-up');
        const header = document.querySelector('header[data-role="heading"]');
        const headerHeight = header.clientHeight;
        const mainTag = document.querySelector('main[role="main"]');
        const mainDiv = document.querySelector('.main-content');

        $('#js-texto-header').slick({
          arrows: false,
          infinite: false,
          autoplay: true,
          autoplaySpeed:1000, 
          dots: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: 1000,
        });

        if(headerTransparent) {
          if(view_origin != "home") {
            if (mainTag) {
              mainTag.style.paddingTop = `${headerHeight}px`;
            } else {
              mainDiv.style.paddingTop = `${headerHeight}px`;
            }
          }
        } else {
          if (mainTag) {
            mainTag.style.paddingTop = `${headerHeight}px`;
          } else {
            mainDiv.style.paddingTop = `${headerHeight}px`;
          }
        }  
      },
      runSpeechRecognition() {
        var isChromium = window.chrome;
        var winNav = window.navigator;
        var vendorName = winNav.vendor;
        var isOpera = typeof window.opr !== "undefined";
        var isIEedge = winNav.userAgent.indexOf("Edge") > -1;
        var isIOSChrome = winNav.userAgent.match("CriOS");

        if(isChromium !== null && typeof isChromium !== "undefined" && vendorName === "Google Inc." && isOpera === false && isIEedge === false) {
          let output = document.querySelector(".output-search");
          let action = document.querySelector(".microphone");
          let inputMic = document.querySelector(".search__text");
      
          var SpeechRecognition = SpeechRecognition || webkitSpeechRecognition;
  
          var recognition = new SpeechRecognition();
          recognition.continuous = false;
          recognition.lang = 'pt-BR';
  
      
          recognition.onstart = function() {
          if (!output.classList.contains("hide")) {
              output.classList.toggle("hide");
          }   
          
          action.classList.toggle('active');
          };
          
          recognition.onspeechend = function() {
          
          action.classList.toggle('active');
              recognition.stop();
          }
      
          recognition.onresult = function(event) {
              var transcript = event.results[0][0].transcript;
              var confidence = event.results[0][0].confidence * 100;
          
              if(confidence < 50) {
                  inputMic.classList.toggle('not-understand')
                  output.classList.toggle("hide");
                  inputMic.value = "Desculpe não entendi muito bem.";
              } else {
                  inputMic.value = transcript
                  document.querySelector('.search__submit').click()
              };
              
          };
      
          // start recognition
          recognition.start();
        } else return document.querySelector(".microphone-search").remove();
      },
      handleScroll() {
          const st = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
          const scrollDifference = st - this.lastScrollTop;
          const customMobile = document.getElementById('custom-mobile-nav');
          const headerThird = document.getElementById('header-third');
          const quickMenu = document.getElementById('quick-menu-id');
          const whatsappWidget = document.getElementById('widget-whatsapp');

          if (st > this.lastScrollTop)
              this.header.isNavUp = false;
          else {
              if (st === 0) 
                this.header.isNavUp = true;
          }

          if (st >= 90 && scrollDifference > 0) {
            this.header.isNavDown     = false;
            this.header.isNavMin      = true;

            if (customMobile)
              customMobile.classList.add('hide');

            if (headerThird)
              headerThird.classList.add('hide');

            if (quickMenu) {
              quickMenu.classList.add('hide');
              whatsappWidget.style.bottom = '';
            }

          } else {
            this.header.isNavDown     = true;
            this.header.isNavMin      = false;
            this.header.isNavMenuHide = false;

            if (customMobile)
              customMobile.classList.remove('hide');

            if (headerThird)
              headerThird.classList.remove('hide');

            if (quickMenu) {
              quickMenu.classList.remove('hide');
              whatsappWidget.style.bottom = '79px';
            }
          }

          this.lastScrollTop = st;
      },
      filterItems(item1, item2, item3, item4) {
        var data = [item1, item2, item3, item4];

        for (var i = 0; i < data.length; i++) {
          var element = document.querySelector('[item="' + data[i] + '"]');
          switch (data[i]) {
            case "home":
                element.setAttribute('href', '/');
                break;
            case "menu":
                var newSpan = document.createElement('span');
                newSpan.setAttribute('class', 'quick-menu__item--link toggleMenu js-mobile-nav-trigger');

                while (element.firstChild) {
                  newSpan.appendChild(element.firstChild);
                }

                element.parentNode.replaceChild(newSpan, element);
                break;
            case "cart":
                element.setAttribute('href', '/carrinho');
                break;
            case "user":
                element.setAttribute('href', '/clientes/identificacao/?next=/clientes/minha-conta/');
                break;
            case "wishlist":
                element.setAttribute('href', '/clientes/minha-conta/minha-lista-de-produtos/');
                break;
          }
        }
      }
    },
    mounted() {
      this.addPaddingHeader();

      window.addEventListener('scroll', this.handleScroll);

      let item1, item2, item3, item4

      if(document.getElementById('quick-item-1')) {
        item1 = document.getElementById('quick-item-1').getAttribute('item');
      }
      if(document.getElementById('quick-item-2')) {
        item2 = document.getElementById('quick-item-2').getAttribute('item');
      }
      if(document.getElementById('quick-item-3')) {
        item3 = document.getElementById('quick-item-3').getAttribute('item');
      }
      if(document.getElementById('quick-item-4')) {
        item4 = document.getElementById('quick-item-4').getAttribute('item');
      }
      
      if(item1 && item2 && item3 && item4) {
        this.filterItems(item1, item2, item3, item4);
      }
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    watch: {
      cartOpened(newValue) {
        if (newValue) {
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.removeProperty('overflow');
        }
      },

      searchOpened(newValue) {
        if (newValue) {
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.removeProperty('overflow');
        }
      },
    }
})

/* Mobile Wrapper */
const mobileNavLinks = document.querySelectorAll('.mobile-nav__link.ewrap');

mobileNavLinks.forEach(link => {
  link.addEventListener('click', function(event) {
    event.preventDefault();
    this.classList.toggle('active');
    const wrapper = this.nextElementSibling;
    if (wrapper && wrapper.tagName === 'UL') {
      wrapper.classList.toggle('active');
    }
  });
});

/* Mobile Search Toggle */
const mobileSearchIcon = document.querySelector('.header__second--tools-search-mobile .search-icon');

if (mobileSearchIcon) {
  mobileSearchIcon.addEventListener('click', function() {
    this.classList.toggle('active');
  });
}
